import dayjs from "dayjs";
import { useAppSelector } from "../../app/store";
import IMG_On_Leave from "../../assets/images/dashboard/On Leave.svg";
import IMG_Pending_Request from "../../assets/images/dashboard/Pending Request.svg";
import { dbDateFormat } from "../../constants/constants";
import { useGetDashboardLeaveAnalyticsDataQuery } from "../../features/leaveApplication/leaveApplicationApi";
import useError from "../../hooks/useError";
import HeaderTitle from "./HeaderTitle";
import TopBarCard from "./TopBarCard";

export default function LeaveCards() {
  const { authInfo } = useAppSelector((state) => state.auth);

  const { data, isError, error } = useGetDashboardLeaveAnalyticsDataQuery({});
  useError(isError, error, "Get leave analytics data fail");

  const dataList = data?.data;

  const topBarData = [
    {
      title: "On Leave",
      count: dataList?.numberOfAcceptedToday,
      img: IMG_On_Leave,
      color: "#FFF5F4",
      link: "/admin/leave/leave-requests",
      query: `from_date=${dayjs().format(
        dbDateFormat
      )}&to_date=${dayjs().format(dbDateFormat)}&status=accepted`,
    },
    {
      title: "Pending",
      count: dataList?.numberOfPendingApprovals,
      img: IMG_Pending_Request,
      color: "#FFF6ED",
      link: "/admin/leave/leave-requests",
      query: `approver_status=pending&approver_id=${authInfo?.id}`,
    },
  ];

  return (
    <div className="mt-6">
      <HeaderTitle title="leave" />

      <div className="grid md:grid-cols-4 sm:grid-cols-2 gap-6">
        {topBarData.map((item) => (
          <TopBarCard {...item} count={item.count || 0} key={item.title} />
        ))}
      </div>
    </div>
  );
}
